// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__wFFiH","headerText":"Header_headerText__Tx+Kr"};